module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/assert/~/util/support/isBufferBrowser.js
// module id = 564
// module chunks = 35783957827783 193747675109532